<template>
  <svg class="icon"
       xmlns="http://www.w3.org/2000/svg"
       width="8"
       height="8"
       viewBox="0 0 8 8"
       fill="none"
  >
    <rect y="3.5"
          width="8"
          height="1"
          fill="#1E2945"
    />
    <rect x="4.5"
          width="8"
          height="1"
          transform="rotate(90 4.5 0)"
          fill="#1E2945"
    />
  </svg>
</template>
